import { useCallback, useEffect, useState } from 'react';
import { useModal } from '../contexts';
import { OAuthError, postData } from '../backend';
import OAuthModalMicrosoft from './OAuthModalMicrosoft';
import MicrosoftFileBrowser from './MicrosoftFileBrowser';

interface Props {
  className?: string;
  style?: any;
  blockType?: string;
  multipleBlockTypes?: Array<string>;
  disabled?: boolean;
  folder?: boolean;
  displayUploadTab?: boolean;
  openOnLoad?: boolean;
  onPicked: (fileId: string, driveId?: string) => void;
  children: JSX.Element | JSX.Element[];
  allowedFileTypes: string;
}

function MicrosoftPickerButton(props: Props) {
  const [pickerIsOpen, setPickerIsOpen] = useState<boolean>(false);

  const [oauthUrl, setOauthUrl] = useState<string>();
  const [isReady, setIsReady] = useState(false);

  const [checkToken, setCheckToken] = useState(true);

  const { openModal } = useModal();

  useEffect(() => {
    if (checkToken)
      postData("/microsoft/access-token/", {})
        .then(() => { setIsReady(true); setOauthUrl(undefined) })
        .catch(error => {
          if (error instanceof OAuthError)
            setOauthUrl(error.oauthUrl);
          else
            console.error(error)
        })
        .finally(() => setCheckToken(false));
  }, [checkToken]);

  const openMicrosoftPicker = useCallback(() => {
    if (oauthUrl)
      return openModal(<OAuthModalMicrosoft oauthUrl={oauthUrl} onClose={() => setCheckToken(true)} />);

    if (props.disabled || !isReady)
      return;

    // NOTE: This never set back to false, this is just to prevent `openOnLoad` from opening the picker multiple times.
    setPickerIsOpen(true);

    openModal(
      <MicrosoftFileBrowser
        onSelect={props.onPicked}
        allowedFileTypes={props.allowedFileTypes}
        mode={props.folder ? 'folder' : 'file'}
      />
    );

  }, [props, oauthUrl, isReady, openModal]);

  useEffect(() => {
    if (props.openOnLoad && !pickerIsOpen)
      openMicrosoftPicker();
  }, [props.openOnLoad, isReady, oauthUrl, openMicrosoftPicker, pickerIsOpen]);

  return (
    <button style={props.style} className={props.className} onClick={openMicrosoftPicker} disabled={props.disabled || (!oauthUrl && !isReady)}>
      {props.children}
    </button>
  );
}

export default MicrosoftPickerButton;
